import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const getEffortSuccessCriteria = async (effortId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/business/efforts/${effortId}/success_criteria/`,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching success criteria:", error);
    throw error;
  }
};

export const createEffortSuccessCriteria = async (effortId, criteriaData) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/business/efforts/${effortId}/success_criteria/`,
      criteriaData,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error creating success criteria:", error);
    throw error;
  }
};

export const updateEffortSuccessCriteria = async (
  effortId,
  criteriaId,
  criteriaData
) => {
  try {
    const response = await axios.put(
      `${baseUrl}/api/business/efforts/${effortId}/success_criteria/${criteriaId}/`,
      criteriaData,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error updating success criteria:", error);
    throw error;
  }
};

export const deleteEffortSuccessCriteria = async (effortId, criteriaId) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/api/business/efforts/${effortId}/success_criteria/${criteriaId}/`,
      getConfig()
    );
    return response.status === 204;
  } catch (error) {
    console.error("Error deleting success criteria:", error);
    throw error;
  }
};
